/* --------------------------------------------------------------------------------------
   autoPostForm.component.js
   Copyright © 2021 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const autoPostFormComponent = {
  template: `
    <form method="post" action="{{ vm.options.url | trusted }}" name="{{vm.options.id}}" id="{{vm.options.id}}">
      <input ng-repeat="(key, val) in vm.options.params" type="hidden" name="{{key}}" value="{{val}}">
    </form>
  `,
  bindings: {
    options: '<'
  },
  controllerAs: 'vm',
  controller: class autoPostFormController {
    $onInit() {
      setTimeout(() => angular.element('#' + this.options.id).submit(),100)
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common/components/autoPostForm.component.js